import { ImageField, TextField } from "./SettingsFields";

function BrandingSettingsForm({ settings, onChange, onFileChange }) {
  return (
    <section className="admin-settings-section">
      <ImageField label="Logo" name="logo" value={settings.logo} clearName="clear_logo" onChange={onChange} onFileChange={onFileChange} />
      <TextField label="Facebook URL" name="facebook_url" value={settings.facebook_url} onChange={onChange} />
      <TextField label="Instagram URL" name="instagram_url" value={settings.instagram_url} onChange={onChange} />
      <TextField label="TikTok URL" name="tiktok_url" value={settings.tiktok_url} onChange={onChange} />
    </section>
  );
}

export default BrandingSettingsForm;